export default __webpack_public_path__ + "static/media/truck_light.21b584d5.png";